import { ControlGroupOption, IconData } from "@gravity-ui/uikit";
import { CounterType } from "definitions/poizon-bff";
import { DewuLogo, PoizonComLogo } from "src/components";

export const SUBSCRIBE_DURATIONS = [
  {
    value: "1",
    content: "1 Месяц",
    title: "1 Месяц",
  },
];

export const platforms: (ControlGroupOption<CounterType> & {
  icon: IconData;
})[] = [
  {
    value: CounterType.DewuRequests,
    content: "Dewu",
    icon: DewuLogo,
  },
  {
    value: CounterType.PoizonRuRequests,
    content: "Poizon RU",
    icon: PoizonComLogo,
  },
];
